export { default } from "./SearchSmart";
